/**
 * BotView test IDs — every interactive element gets a unique data-testid.
 */
export const TEST_IDS = {
  // Auth gate
  AUTH_GATE_SCREEN: 'auth-gate-screen',
  AUTH_GATE_TITLE: 'auth-gate-title',
  AUTH_GATE_TAGLINE: 'auth-gate-tagline',
  AUTH_GATE_CTA: 'auth-gate-cta-btn',

  // TopBar
  TOPBAR: 'topbar',
  THEME_TOGGLE_BTN: 'theme-toggle-btn',
  USER_AVATAR: 'user-avatar',
  USER_NAME: 'user-name',
  LOGOUT_BTN: 'logout-btn',

  // Sidebar
  SIDEBAR: 'sidebar',
  NAV_DASHBOARD: 'nav-dashboard-link',
  NAV_INTERVIEWS: 'nav-interviews-link',
  NAV_PROGRESS: 'nav-progress-link',
  NAV_KNOWLEDGE: 'nav-knowledge-link',
  NAV_LEADERBOARD: 'nav-leaderboard-link',
  NAV_SENTIMENT: 'nav-sentiment-link',
  NAV_SETTINGS: 'nav-settings-link',

  // Bottom Nav
  BOTTOM_NAV: 'bottom-nav',
  BOTTOM_NAV_DASHBOARD: 'bottom-nav-dashboard',
  BOTTOM_NAV_INTERVIEWS: 'bottom-nav-interviews',
  BOTTOM_NAV_PROGRESS: 'bottom-nav-progress',
  BOTTOM_NAV_SETTINGS: 'bottom-nav-settings',

  // Dashboard
  DASHBOARD: 'dashboard-page',
  DASHBOARD_WELCOME: 'dashboard-welcome',
  PROGRESS_RING: 'progress-ring',
  STAT_CARD: 'stat-card',

  // Shared
  LOADING_SPINNER: 'loading-spinner',

  // Interview Setup
  INTERVIEW_SETUP: 'interview-setup-page',
  MODE_COMPANY: 'mode-company-btn',
  MODE_TOPIC: 'mode-topic-btn',
  START_CONFIRM: 'start-interview-confirm-btn',
  BACK_TO_DASHBOARD: 'back-to-dashboard-btn',
};
